module.exports = __webpack_public_path__ + "static/media/ai-revamp-text.cf2dd0db.png";